import React, { useEffect, useState } from "react";
import {
    Box,
    TextField,
    Typography,
    Button,
    FormControlLabel,
    Card,
    CardContent,
    CircularProgress,
    Switch,
    CardMedia,
    Alert,
    Grid,
    Avatar,
    Checkbox,
} from "@mui/material";
import { emptyProperty, FullProperty } from "../models/fullProperty";
import { StringsService } from "../services/strings/strings";
import { restaurantService } from "../services/firebase/restaurantManagementService";
import { useSignedInUserState } from "../hooks/useAuthState";
import { DropzoneState, useDropzone } from "react-dropzone";
import { ImageService } from "../services/images/images";
import { Close } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import { ImageGalleryType } from "../models/imageGallery";
import "./createRestaurant.css"
import { BankingDetailstype } from "../models/bankingDetailsType";
import { RestaurantAPIService } from "../services/functions/restaurantAPIService";
import { ConfirmActionDialog } from "../shared/confirmActionDialog";
import { Autocomplete } from "@react-google-maps/api";
import MapDialog, { Coordinates } from "../listingSearchPage/dialog/mapDialog";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MetricsNames } from "../services/firebase/metricsService";
import { ProfileService } from "../services/profile/profile";
import { logEvent } from "../firebase";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

declare global {
    interface Window {
        google: any;
    }
}

interface RestaurantDetails {
    "thumbnail": string; // this is a link to an image, This will need to be displayed on the page when a customer is configuring the experiment.
    "restaurant-name": string;
    "restaurant-surprise-box-price-zar-displayable": string;
    "short-restaurant-summary": string;
    "full-restaurant-summary": string;
}

interface PlaceDetails {
    address: string;
    coordinates: Coordinates | null;
    placeId?: string;
    name?: string;
}
const GOOGLE_PLACES_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
console.log("process.env.REACT_APP_GOOGLE_API_KEY", process.env.REACT_APP_GOOGLE_API_KEY)
export const CreateRestaurantPage: React.FC<{ editRestaurant: FullProperty | null, onRestaurantUpdate: (newRestaurant: FullProperty) => void }> = ({ editRestaurant, onRestaurantUpdate }) => {
    const user = useSignedInUserState();
    const [restaurant, setRestaurant] = useState<FullProperty>(emptyProperty);
    const [existingRestaurant, setExistingRestaurant] = useState<FullProperty | null>(null);
    const [restaurantFormData, setRestaurantFormData] = useState<RestaurantFormData | null>(null);
    const [addressInput, setAddressInput] = useState<string>("");
    const [loadingLocation, setLoadingLocation] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const [restaurantBankingDetails, setRestaurantBankingDetails] = useState<BankingDetailstype>({
        accountNumber: "",
        branchCode: ""
    });
    // New state for restaurant details
    const [restaurantDetails, setRestaurantDetails] = useState<RestaurantDetails>({
        "thumbnail": "",
        "restaurant-name": "",
        "restaurant-surprise-box-price-zar-displayable": "",
        "short-restaurant-summary": "",
        "full-restaurant-summary": ""
    });
    const [uploadedImages, setUploadedImages] = useState<{ file: File; previewUrl: string }[]>([]);
    const [oldGalleryImages, setOldGalleryImages] = useState<string[]>([]); // URLs of previously uploaded images
    const [thumbnailImage, setThumbnailImage] = useState<File | null>(null);
    const [oldThumbnailImage, setOldThumbnailImage] = useState<string | null>(null);
    const [showDeactivateRestaurantConfirmationDialog, setShowDeactivateRestaurantConfirmationDialog] = useState<boolean>(false)


    const [scriptLoaded, setScriptLoaded] = useState(false);
    const [options, setOptions] = useState<google.maps.places.AutocompletePrediction[]>([]);

    const libraries: ("places")[] = ["places"];

    const daysOfWeek = [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
        'Holiday',
    ];

    const dayNameMap = [
        { day: 'Monday', startField: 'mondayStart', endField: 'mondayEnd', offlineField: "offlineMonday" },
        { day: 'Tuesday', startField: 'tuesdayStart', endField: 'tuesdayEnd', offlineField: "offlineTuesday" },
        { day: 'Wednesday', startField: 'wednesdayStart', endField: 'wednesdayEnd', offlineField: "offlineWednesday" },
        { day: 'Thursday', startField: 'thursdayStart', endField: 'thursdayEnd', offlineField: "offlineThursday" },
        { day: 'Friday', startField: 'fridayStart', endField: 'fridayEnd', offlineField: "offlineFriday" },
        { day: 'Saturday', startField: 'saturdayStart', endField: 'saturdayEnd', offlineField: "offlineSaturday" },
        { day: 'Sunday', startField: 'sundayStart', endField: 'sundayEnd', offlineField: "offlineSunday" },
        { day: 'Holiday', startField: 'holidayStart', endField: 'holidayEnd', offlineField: "offlineHoliday" },
    ] as const;

    useEffect(() => {
        if (!window.google) {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_PLACES_API_KEY}&libraries=${libraries}`;
            script.async = true;
            script.onload = () => {
                setScriptLoaded(true);
            };
            document.head.appendChild(script);
        } else {
            setScriptLoaded(true);
        }
    }, []);

    //Storage Key
    const LOCAL_STORAGE_KEY = "localLocation";

    useEffect(() => {
        const fetchStrings = async () => {
            if (editRestaurant) {
                try {
                    let restaurantId = editRestaurant.id
                    const storedRestaurnat = editRestaurant ? editRestaurant : await restaurantService.fetchRestaurantById(restaurantId);
                    setRestaurant(storedRestaurnat)
                    setValue("name", storedRestaurnat.name);
                    setValue("addressName", storedRestaurnat.addressName);
                    setValue("mondayStart", storedRestaurnat!.mondayStart);
                    setValue("mondayEnd", storedRestaurnat!.mondayEnd);
                    setValue("tuesdayStart", storedRestaurnat!.tuesdayStart);
                    setValue("tuesdayEnd", storedRestaurnat!.tuesdayEnd);
                    setValue("wednesdayStart", storedRestaurnat!.wednesdayStart);
                    setValue("wednesdayEnd", storedRestaurnat!.wednesdayEnd);
                    setValue("thursdayStart", storedRestaurnat!.thursdayStart);
                    setValue("thursdayEnd", storedRestaurnat!.thursdayEnd);
                    setValue("fridayStart", storedRestaurnat!.fridayStart);
                    setValue("fridayEnd", storedRestaurnat!.fridayEnd);
                    setValue("saturdayStart", storedRestaurnat!.saturdayStart);
                    setValue("saturdayEnd", storedRestaurnat!.saturdayEnd);
                    setValue("sundayStart", storedRestaurnat!.sundayStart);
                    setValue("sundayEnd", storedRestaurnat!.sundayEnd);

                    setValue("offlineMonday", storedRestaurnat!.offlineMonday);
                    setValue("offlineTuesday", storedRestaurnat!.offlineTuesday);
                    setValue("offlineWednesday", storedRestaurnat!.offlineWednesday);
                    setValue("offlineThursday", storedRestaurnat!.offlineThursday);
                    setValue("offlineFriday", storedRestaurnat!.offlineFriday);
                    setValue("offlineSaturday", storedRestaurnat!.offlineSaturday);
                    setValue("offlineSunday", storedRestaurnat!.offlineSunday);
                    setValue("offlineHoliday", storedRestaurnat!.offlineHoliday);

                    setValue("holidayStart", storedRestaurnat!.holidayStart);
                    setValue("holidayEnd", storedRestaurnat!.holidayEnd);
                    setValue("franchise", storedRestaurnat.franchise);
                    setExistingRestaurant(storedRestaurnat)
                    setRestaurantDetails({
                        "thumbnail": await StringsService.getStringById(`${restaurantId}-thumbnail`),
                        "restaurant-name": await StringsService.getStringById(`${restaurantId}-restaurant-name`),
                        "restaurant-surprise-box-price-zar-displayable": await StringsService.getStringById(`${restaurantId}-restaurant-surprise-box-price-zar-displayable`),
                        "short-restaurant-summary": await StringsService.getStringById(`${restaurantId}-short-restaurant-summary`),
                        "full-restaurant-summary": await StringsService.getStringById(`${restaurantId}-full-restaurant-summary`)
                    })

                    const addressName = storedRestaurnat.addressName;
                    setAddressInput(addressName)

                    const imageUrls = (await ImageService.getGalleryImages(restaurantId)).map(img => img.original);
                    setOldGalleryImages(imageUrls); // Populate oldImages with URLs
                    const oldThumb = await StringsService.getStringById(`${restaurantId}-thumbnail`);
                    if (oldThumb != "") {
                        setOldThumbnailImage(oldThumb)
                    }

                    const restaurantBankingDetails = await RestaurantAPIService.getBankingDetails(restaurantId)
                    if (restaurantBankingDetails) {
                        setRestaurantBankingDetails(restaurantBankingDetails)
                    }
                    setValue("accountNumber", restaurantBankingDetails?.accountNumber ?? "");
                    setValue("branchCode", restaurantBankingDetails!.branchCode);

                } catch (error) {
                    console.error("Error", error);
                }
            };
        };
        fetchStrings();
    }, [editRestaurant]);

    const handleRemoveImage = (index: number) => {
        const uploadedImageUrls = uploadedImages.map((img) => img.previewUrl);
        const allImages = [...oldGalleryImages, ...uploadedImageUrls];
        const srcToRemove = allImages[index];

        if (oldGalleryImages.includes(srcToRemove)) {
            setOldGalleryImages((prev) => prev.filter((src) => src !== srcToRemove));
        } else {
            setUploadedImages((prev) => {
                const updated = prev.filter((img) => img.previewUrl !== srcToRemove);
                const removed = prev.find((img) => img.previewUrl === srcToRemove);
                if (removed) URL.revokeObjectURL(removed.previewUrl);
                return updated;
            });
        }
    };

    const { getRootProps, getInputProps } = useDropzone({
        accept: { "image/*": [] },
        maxSize: 5 * 1024 * 1024, // Maximum file size (e.g., 5 MB)
        onDrop: (acceptedFiles) => {
            if (acceptedFiles.length > 0) {
                const supportedFiles = acceptedFiles
                    .filter((file) => file.type.startsWith("image/"))
                    .map((file) => ({
                        file,
                        previewUrl: URL.createObjectURL(file),
                    }));

                setUploadedImages((prev) => [...prev, ...supportedFiles]);
            }
        },
        onDropRejected: (fileRejections) => {
            // Handle errors for rejected files
            fileRejections.forEach((rejection) => {
                rejection.errors.forEach((error) => {
                    console.error(`Error: ${error.message}`);
                });
            });
        },
    });

    const thumbnailProps: DropzoneState = useDropzone({
        accept: { "image/*": [] },
        maxFiles: 1,
        maxSize: 5 * 1024 * 1024, // Maximum file size (e.g., 5 MB)
        onDrop: (acceptedFiles: File[]) => {
            if (acceptedFiles.length > 0) {
                const file = acceptedFiles[0];
                if (file.type.startsWith("image/")) {
                    // Proceed with the file processing
                    setOldThumbnailImage(null)
                    setThumbnailImage(file);
                } else {
                    console.error("Invalid file type");
                }
            }
        },
        onDropRejected: (fileRejections) => {
            // Handle errors for rejected files
            fileRejections.forEach((rejection) => {
                rejection.errors.forEach((error) => {
                    console.error(`Error: ${error.message}`);
                });
            });
        },
    });
    const handleInputChange = (field: keyof FullProperty, value: any) => {
        setRestaurant((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleRestaurantDetailsChange = (key: keyof RestaurantDetails, value: string) => {
        setRestaurantDetails((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleLocationQuery = async () => {
        if (!addressInput || !addressInput.trim()) return;

        setLoadingLocation(true);
        try {
            const encodedAddress = encodeURIComponent(placeDetails.address);
            const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${GOOGLE_PLACES_API_KEY}`;

            const response = await fetch(url);
            const data = await response.json();

            if (data.status === "OK" && data.results.length > 0) {
                setRestaurant({
                    ...restaurant,
                    location: data.results[0].geometry.location,
                    addressName: data.results[0].formatted_address,
                });
                const lat = data.results[0].geometry.location.lat
                const lng = data.results[0].geometry.location.lng
                const queryCoords: Coordinates = { lat, lng };
                localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(queryCoords));
                setSuccessMessage(await StringsService.getStringById("success-address-fetch"));
            } else {
                setErrorMessage(await StringsService.getStringById("error-address-not-found"));
            }
        } catch (error) {
            setErrorMessage(await StringsService.getStringById("error-address-failure"));
        } finally {
            setLoadingLocation(false);
        }
    };

    const getAddressFromCoordinates = async ({ lat, lng }: Coordinates): Promise<string | null> => {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_PLACES_API_KEY}`;

        try {
            const response = await fetch(url);
            console.log(response)
            const data = await response.json();
            console.log(data)

            if (data.status === "OK" && data.results.length > 0) {
                return data.results[0].formatted_address;
            } else {
                console.log("not an error just missing data", data.status === "OK", data.results.length > 0)
                // toast.error("There was an error getting your location from Google. Please try again.")
                logEvent(MetricsNames.GEOCODING_FAILURE, {
                    "status": data.status,
                    "resultsLength": data.results.length
                })
                return null;
            }
        } catch (error) {
            console.log(error)
            // toast.error("There was an error getting your location from Google. Please try again.")
            logEvent(MetricsNames.GEOCODING_FAILURE, {
                "error": error,
            })
            return null;
        }
    };

    const handleSubmitResaurant = async (data: RestaurantFormData) => {
        if (!user || !user.user || !user.user!.uid || !user.profile) {
            setErrorMessage(await StringsService.getStringById("error-not-signed-in"));
            return;
        }
        setLoading(true);
        setErrorMessage("");
        console.log(restaurant)
        try {
            restaurant.owner = user?.user!.uid;
            restaurant.mondayStart = data.mondayStart ?? "";
            restaurant.mondayEnd = data.mondayEnd ?? "";

            restaurant.tuesdayStart = data.tuesdayStart ?? "";
            restaurant.tuesdayEnd = data.tuesdayEnd ?? "";

            restaurant.wednesdayStart = data.wednesdayStart ?? "";
            restaurant.wednesdayEnd = data.wednesdayEnd ?? "";

            restaurant.thursdayStart = data.thursdayStart ?? '';
            restaurant.thursdayEnd = data.thursdayEnd ?? "";

            restaurant.fridayStart = data.fridayStart ?? "";
            restaurant.fridayEnd = data.fridayEnd ?? "";

            restaurant.saturdayStart = data.saturdayStart ?? "";
            restaurant.saturdayEnd = data.saturdayEnd ?? "";

            restaurant.sundayStart = data.sundayStart ?? "";
            restaurant.sundayEnd = data.sundayEnd ?? "";

            restaurant.holidayStart = data.holidayStart ?? "";
            restaurant.holidayEnd = data.holidayEnd ?? "";

            restaurant.offlineMonday = data.offlineMonday;
            restaurant.offlineTuesday = data.offlineTuesday;
            restaurant.offlineWednesday = data.offlineWednesday;
            restaurant.offlineThursday = data.offlineThursday;
            restaurant.offlineFriday = data.offlineFriday;
            restaurant.offlineHoliday = data.offlineHoliday;

            restaurant.endDateDayDeltaFromNow = 0;
            restaurant.startOfCollectionTimeDayDeltaFromNow = 0;

            let restaurantId = editRestaurant ? editRestaurant.id : null
            if (restaurantId) {
                console.log(restaurant.tuesdayEnd);
                restaurant.id = restaurantId;
                const partialUpdate: Partial<FullProperty> = {
                    // Basic identity
                    name: restaurant.name,

                    // Operational metadata
                    franchise: restaurant.franchise,
                    mondayStart: restaurant.mondayStart,
                    mondayEnd: restaurant.mondayEnd,
                    tuesdayStart: restaurant.tuesdayStart,
                    tuesdayEnd: restaurant.tuesdayEnd,
                    wednesdayStart: restaurant.wednesdayStart,
                    wednesdayEnd: restaurant.wednesdayEnd,
                    thursdayStart: restaurant.thursdayStart,
                    thursdayEnd: restaurant.thursdayEnd,
                    fridayStart: restaurant.fridayStart,
                    fridayEnd: restaurant.fridayEnd,
                    saturdayStart: restaurant.saturdayStart,
                    saturdayEnd: restaurant.saturdayEnd,
                    sundayStart: restaurant.sundayStart,
                    sundayEnd: restaurant.sundayEnd,
                    holidayStart: restaurant.holidayStart,
                    holidayEnd: restaurant.holidayEnd,
                    endDateDayDeltaFromNow: 0,
                    startOfCollectionTimeDayDeltaFromNow: 0,
                    

                    offlineMonday: restaurant.offlineMonday,
                    offlineTuesday: restaurant.offlineTuesday,
                    offlineWednesday: restaurant.offlineWednesday,
                    offlineThursday: restaurant.offlineThursday,
                    offlineFriday: restaurant.offlineFriday,
                    offlineSaturday: restaurant.offlineSaturday,
                    offlineSunday: restaurant.offlineSunday,
                    offlineHoliday: restaurant.offlineHoliday,

                    // Location data
                    addressName: restaurant.addressName,
                    location: restaurant.location,               // { lat: number; lng: number }

                    // Visibility
                    isActive: restaurant.isActive,
                    isAutoTradeEnabled: restaurant.isAutoTradeEnabled,

                    // customer interaction
                    enableCustomerSettlement: restaurant.enableCustomerSettlement
                };
                await restaurantService.editRestaurant(restaurantId, partialUpdate);
            } else {
                restaurantId = await restaurantService.createRestaurant(restaurant);
                if (user.profile.profileType === "user") {
                    user.profile.profileType = "owner"
                    await ProfileService.updateProfile(user.profile.id, { profileType: "owner" })
                }
                restaurant.id = restaurantId
            }
            if (existingRestaurant && existingRestaurant?.isActive != restaurant.isActive) {
                restaurantService.changeRestaurantActivityStatus(restaurantId!, restaurant.isActive, user.profile!)
                if (!restaurant.isActive) {
                    restaurant.isPublished = false
                }
            }

            // restaurantService.updateSaleItemsEndDatesOnAutoTradeEnabled(restaurantId!, restaurant.isAutoTradeEnabled, user.profile!)

            // update thumbnail url
            // This is only needed if we are changing the thumbnail, else we can ignore it.
            if (thumbnailImage) {
                const thumbnailUrl: string = (await ImageService.uploadImagesToStorage([thumbnailImage]))[0];
                await StringsService.updateStringById(
                    `${restaurantId}-thumbnail`,
                    thumbnailUrl
                )
            }
            await upsertStrings(restaurantId);
            await handleImageUpload(restaurantId);
            await RestaurantAPIService.setBankingDetails(restaurantId, restaurantBankingDetails)
            setSuccessMessage("Restaurant created successfully!");
            onRestaurantUpdate(restaurant)
        } catch (err) {
            console.log(err)
            setErrorMessage("Failed to create restaurant. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const upsertStrings = async (id: string) => {
        await StringsService.updateStringById(
            `${id}-restaurant-name`,
            restaurantDetails["restaurant-name"]
        )
        await StringsService.updateStringById(
            `${id}-restaurant-surprise-box-price-zar-displayable`,
            restaurantDetails["restaurant-surprise-box-price-zar-displayable"]
        )
        await StringsService.updateStringById(
            `${id}-short-restaurant-summary`,
            restaurantDetails["short-restaurant-summary"]
        )
        await StringsService.updateStringById(
            `${id}-full-restaurant-summary`,
            restaurantDetails["full-restaurant-summary"]
        )
    }

    const handleImageUpload = async (propertyId: string) => {
        if (uploadedImages.length === 0) return;

        // Extract File objects from uploadedImages
        const filesToUpload = uploadedImages.map((item) => item.file);

        // Upload to storage
        const uploadedUrls = await ImageService.uploadImagesToStorage(filesToUpload);
        console.log("Uploaded URLs:", uploadedUrls);

        // Merge old and new URLs
        const allImageUrls: ImageGalleryType[] = [
            ...oldGalleryImages.map((s) => ({
                original: s,
                thumbnail: s,
            })),
            ...uploadedUrls.map((url) => ({
                original: url,
                thumbnail: url,
            })),
        ];

        // Update backend
        await ImageService.setGalleryImages(propertyId, allImageUrls);
        console.log("Gallery images updated!");

        // Update state: add uploaded URLs to old images
        setOldGalleryImages((prev) => [...prev, ...uploadedUrls]);

        // Revoke object URLs to free memory
        uploadedImages.forEach((img) => URL.revokeObjectURL(img.previewUrl));

        // Clear uploadedImages state
        setUploadedImages([]);
    };

    const activeThumbnail = (): string | null => {
        if (thumbnailImage) {
            return URL.createObjectURL(thumbnailImage);
        }
        if (oldThumbnailImage) {
            return oldThumbnailImage;
        }
        return null
    }

    const [autocomplete, setAutocomplete] = useState<google.maps.places.Autocomplete | null>(null);
    const [openModal, setOpenModal] = useState(false);

    const [placeDetails, setPlaceDetails] = useState<PlaceDetails>({
        address: "",
        coordinates: null,
        placeId: undefined,
        name: undefined,
    });

    const handlePlaceChanged = () => {
        if (autocomplete) {
            const place = autocomplete.getPlace();
            if (place.geometry) {
                const placeCoords: Coordinates = {
                    lat: place.geometry.location?.lat() || 0,
                    lng: place.geometry.location?.lng() || 0,
                }
                localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(placeCoords));

                setAddressInput(place.formatted_address!);
                handleInputChange("addressName", place.formatted_address!);
                setPlaceDetails({
                    address: place.formatted_address || "",
                    coordinates: placeCoords,
                    placeId: place.place_id,
                    name: place.name,
                });
                setValue("addressName", place.formatted_address!);
                handleLocationQuery()
                setOpenModal(true);
            }
        }
    };

    // Close the modal
    const handleCloseModal = () => {
        setOpenModal(false);
    };

    // Close the modal
    const onConfirm = async (coords: Coordinates) => {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(coords));
        var mapAddress = await getAddressFromCoordinates(coords)
        let addressName = restaurant.addressName
        if (mapAddress) {
            addressName = mapAddress;
            setAddressInput(mapAddress ?? "")
            handleInputChange("addressName", mapAddress);
            setValue("addressName", mapAddress!);
        } else {
            console.log("Address could not be fetched from geocodingAPI")
            // handleInputChange("addressName", "");
            // setValue("addressName", "");
            // setAddressInput("");
        }

        setRestaurant({
            ...restaurant,
            location: coords,
            addressName
        });
        setOpenModal(false);
    };


    const handleAddressInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const input = e.target.value;
        setAddressInput(input);

        if (window.google && window.google.maps) {
            const service = new window.google.maps.places.AutocompleteService();
            service.getPlacePredictions({ input }, (predictions: google.maps.places.AutocompletePrediction[]) => {
                setOptions(predictions || []);
            });
        }
    };
    // Optional: Regex to match SA bank branch codes (6 digits)
    const branchCodeRegex = /^[0-9]{6}$/;

    // Account numbers in SA typically range between 6–11 digits and must be numeric
    const accountNumberRegex = /^[0-9]{6,11}$/;

    const schema = yup.object({
        name: yup.string().required("Name is required"),
        addressName: yup.string().required("Address is required"),
        franchise: yup.string().required("Franchise is required"),

        offlineMonday: yup.boolean().default(false),
        mondayStart: yup.string().nullable().when("offlineMonday", {
            is: false,
            then: (s) => s.required("Start time is required"),
            otherwise: (s) => s.notRequired().nullable(),
        }),
        mondayEnd: yup.string().nullable().when("offlineMonday", {
            is: false,
            then: (s) => s.required("End time is required"),
            otherwise: (s) => s.notRequired().nullable(),
        }),

        offlineTuesday: yup.boolean().default(false),
        tuesdayStart: yup.string().nullable().when("offlineTuesday", {
            is: false,
            then: (s) => s.required("Start time is required"),
            otherwise: (s) => s.notRequired().nullable(),
        }),
        tuesdayEnd: yup.string().nullable().when("offlineTuesday", {
            is: false,
            then: (s) => s.required("End time is required"),
            otherwise: (s) => s.notRequired().nullable(),
        }),

        offlineWednesday: yup.boolean().default(false),
        wednesdayStart: yup.string().nullable().when("offlineWednesday", {
            is: false,
            then: (s) => s.required("Start time is required"),
            otherwise: (s) => s.notRequired().nullable(),
        }),
        wednesdayEnd: yup.string().nullable().when("offlineWednesday", {
            is: false,
            then: (s) => s.required("End time is required"),
            otherwise: (s) => s.notRequired().nullable(),
        }),

        offlineThursday: yup.boolean().default(false),
        thursdayStart: yup.string().nullable().when("offlineThursday", {
            is: false,
            then: (s) => s.required("Start time is required"),
            otherwise: (s) => s.notRequired().nullable(),
        }),
        thursdayEnd: yup.string().nullable().when("offlineThursday", {
            is: false,
            then: (s) => s.required("End time is required"),
            otherwise: (s) => s.notRequired().nullable(),
        }),

        offlineFriday: yup.boolean().default(false),
        fridayStart: yup.string().nullable().when("offlineFriday", {
            is: false,
            then: (s) => s.required("Start time is required"),
            otherwise: (s) => s.notRequired().nullable(),
        }),
        fridayEnd: yup.string().nullable().when("offlineFriday", {
            is: false,
            then: (s) => s.required("End time is required"),
            otherwise: (s) => s.notRequired().nullable(),
        }),

        offlineSaturday: yup.boolean().default(false),
        saturdayStart: yup.string().nullable().when("offlineSaturday", {
            is: false,
            then: (s) => s.required("Start time is required"),
            otherwise: (s) => s.notRequired().nullable(),
        }),
        saturdayEnd: yup.string().nullable().when("offlineSaturday", {
            is: false,
            then: (s) => s.required("End time is required"),
            otherwise: (s) => s.notRequired().nullable(),
        }),

        offlineSunday: yup.boolean().default(false),
        sundayStart: yup.string().nullable().when("offlineSunday", {
            is: false,
            then: (s) => s.required("Start time is required"),
            otherwise: (s) => s.notRequired().nullable(),
        }),
        sundayEnd: yup.string().nullable().when("offlineSunday", {
            is: false,
            then: (s) => s.required("End time is required"),
            otherwise: (s) => s.notRequired().nullable(),
        }),

        offlineHoliday: yup.boolean().default(false),
        holidayStart: yup.string().nullable().when("offlineHoliday", {
            is: false,
            then: (s) => s.required("Start time is required"),
            otherwise: (s) => s.notRequired().nullable(),
        }),
        holidayEnd: yup.string().nullable().when("offlineHoliday", {
            is: false,
            then: (s) => s.required("End time is required"),
            otherwise: (s) => s.notRequired().nullable(),
        }),

        branchCode: yup
            .string()
            .required("Branch code is required")
            .matches(branchCodeRegex, "Branch code must be exactly 6 digits"),

        accountNumber: yup
            .string()
            .required("Account number is required")
            .matches(accountNumberRegex, "Account number must be 6 to 11 digits"),
    })

    type RestaurantFormData = {
        name: string;
        addressName: string;
        franchise: string;

        mondayStart?: string | null;
        mondayEnd?: string | null;
        tuesdayStart?: string | null;
        tuesdayEnd?: string | null;
        wednesdayStart?: string | null;
        wednesdayEnd?: string | null;
        thursdayStart?: string | null;
        thursdayEnd?: string | null;
        fridayStart?: string | null;
        fridayEnd?: string | null;
        saturdayStart?: string | null;
        saturdayEnd?: string | null;
        sundayStart?: string | null;
        sundayEnd?: string | null;
        holidayStart?: string | null;
        holidayEnd?: string | null;

        branchCode: string;
        accountNumber: string;

        offlineMonday: boolean;
        offlineTuesday: boolean;
        offlineWednesday: boolean;
        offlineThursday: boolean;
        offlineFriday: boolean;
        offlineSaturday: boolean;
        offlineSunday: boolean;
        offlineHoliday: boolean;
    };


    const { control, handleSubmit, watch, setValue, reset, formState: { errors } } = useForm<RestaurantFormData>({
        resolver: yupResolver(schema),
        defaultValues: {
            name: "",
            addressName: "",
            franchise: "",
            mondayStart: null,
            mondayEnd: null,
            tuesdayStart: null,
            tuesdayEnd: null,
            wednesdayStart: null,
            wednesdayEnd: null,
            thursdayStart: null,
            thursdayEnd: null,
            fridayStart: null,
            fridayEnd: null,
            saturdayStart: null,
            saturdayEnd: null,
            sundayStart: null,
            sundayEnd: null,
            holidayStart: null,
            holidayEnd: null,
            branchCode: "",
            accountNumber: "",
            offlineMonday: false,
            offlineTuesday: false,
            offlineWednesday: false,
            offlineThursday: false,
            offlineFriday: false,
            offlineSaturday: false,
            offlineSunday: false,
            offlineHoliday: false,
        },
    });
    const onSubmit = (data: RestaurantFormData) => {
        console.log("saving")
        if (existingRestaurant &&
            restaurant &&
            existingRestaurant.isActive &&
            !restaurant.isActive) {
            setShowDeactivateRestaurantConfirmationDialog(true);
            setRestaurantFormData(data);
        } else {
            handleSubmitResaurant(data);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };


    if (loading) {
        return (
            <Box
                className="patlite"
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 2,
                }}
            >
                <CircularProgress size={60} />
            </Box>
        );
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Box
                className="patlite"
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    paddingTop: 4,
                    paddingBottom: 4,
                    paddingRight: 4,
                    width: "100%",
                }}
            >
                <MapDialog open={openModal} onClose={handleCloseModal} onConfirm={onConfirm} user={user} />

                <Box
                    sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "12px",
                        padding: 4,
                        backgroundColor: "#fff",
                        width: "100%",
                        maxWidth: "1000px",
                        marginBottom: "32px",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                    }}
                >
                    <Typography variant="h5" gutterBottom>
                        {editRestaurant ? "Edit Restaurant" : "Create Restaurant"}
                    </Typography>

                    {/* Franchise Field */}
                    <Box sx={{ marginBottom: 3 }}>
                        <Controller
                            name="franchise"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    label="Franchise"
                                    fullWidth
                                    {...field}
                                    onChange={(e) => {
                                        field.onChange(e.target.value);
                                        handleInputChange("franchise", e.target.value);
                                    }}
                                    error={!!errors.franchise}
                                    helperText={errors.franchise?.message}
                                />
                            )}
                        />
                    </Box>

                    {/* Address Autocomplete */}
                    {!scriptLoaded ? (
                        <Typography>Loading Google Places...</Typography>
                    ) : (
                        <Box sx={{ marginBottom: 2 }}>
                            <Controller
                                name="addressName"
                                control={control}
                                render={({ field }) => (
                                    <Autocomplete onLoad={setAutocomplete} onPlaceChanged={handlePlaceChanged}>
                                        <TextField
                                            label="Search Address"
                                            fullWidth
                                            {...field}
                                            onChange={(e) => {
                                                field.onChange(e.target.value);
                                                handleInputChange("addressName", e.target.value);
                                            }}
                                            error={!!errors.addressName}
                                            helperText={errors.addressName?.message}
                                        />
                                    </Autocomplete>
                                )}
                            />
                        </Box>
                    )}

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 2,
                            marginBottom: 1,
                        }}
                    >
                        {/* Active Switch */}
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={restaurant.isActive}
                                    onChange={(e) => handleInputChange("isActive", e.target.checked)}
                                />
                            }
                            label="Active"
                        />
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={restaurant.enableCustomerSettlement}
                                    onChange={(e) =>
                                        handleInputChange("enableCustomerSettlement", e.target.checked)
                                    }
                                />
                            }
                            label="Enable Customer Settlement"
                        />
                    </Box>
                    {restaurant.enableCustomerSettlement && (
                        <Alert severity="warning" icon={false}>
                            <Typography variant="body2">
                                <strong>Warning:</strong> enabling this option allows customers to mark
                                their order as collected without any further confirmation from you.
                            </Typography>
                        </Alert>
                    )}
                    {/* Thumbnail Upload */}
                    <Box sx={{ marginBottom: 3 }}>
                        <Typography variant="h6" gutterBottom>
                            Thumbnail
                        </Typography>
                        <Box
                            {...thumbnailProps.getRootProps()}
                            sx={{
                                border: "2px dashed #cccccc",
                                borderRadius: "8px",
                                padding: 2,
                                textAlign: "center",
                                backgroundColor: "#fafafa",
                            }}
                        >
                            <input {...thumbnailProps.getInputProps()} />
                            <Typography>Drag and drop your thumbnail here, or click to select</Typography>
                        </Box>

                        {activeThumbnail() && (
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    marginTop: 2,
                                    padding: 1,
                                    border: "1px solid #cccccc",
                                    borderRadius: "5px",
                                    backgroundColor: "#ffffff",
                                }}
                            >
                                <CardMedia component="img" height="140" image={activeThumbnail()!} />
                                <IconButton
                                    onClick={() => {
                                        setThumbnailImage(null);
                                        setOldThumbnailImage(null);
                                    }}
                                    sx={{ color: "#ff4d4d" }}
                                >
                                    <Close />
                                </IconButton>
                            </Box>
                        )}
                    </Box>

                    {/* Basic Details */}
                    <Box sx={{ marginBottom: 3 }}>
                        <Controller
                            name="name"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    label="Restaurant Name"
                                    fullWidth
                                    onChange={(e) => {
                                        field.onChange(e);
                                        handleInputChange("name", e.target.value);
                                        handleRestaurantDetailsChange("restaurant-name", e.target.value);
                                    }}
                                    error={!!errors.name}
                                    helperText={errors.name?.message}
                                />
                            )}
                        />
                    </Box>

                    <Box sx={{ marginBottom: 3 }}>
                        <TextField
                            label="Short Summary"
                            fullWidth
                            value={restaurantDetails["short-restaurant-summary"]}
                            onChange={(e) => handleRestaurantDetailsChange("short-restaurant-summary", e.target.value)}
                        />
                    </Box>

                    <Box sx={{ marginBottom: 3 }}>
                        <TextField
                            label="Full Summary"
                            fullWidth
                            multiline
                            rows={4}
                            value={restaurantDetails["full-restaurant-summary"]}
                            onChange={(e) => handleRestaurantDetailsChange("full-restaurant-summary", e.target.value)}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 2,
                            marginBottom: 1,
                        }}
                    >
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box display="flex" flexDirection="column" gap={2}>
                            <Typography variant="h6">Collection Hours</Typography>
                            {dayNameMap.map(({ day, startField, endField, offlineField }) => {
                                const isOffline = watch(offlineField);
                                return (
                                    <Box
                                        key={day}
                                        display="flex"
                                        alignItems="center"
                                        gap={2}
                                        sx={{ borderBottom: "1px solid #ccc", paddingBottom: 1 }}
                                    >
                                        {/* Day Avatar */}
                                        <Avatar
                                            key={day}
                                            sx={{
                                                bgcolor: isOffline ? "#ccc" : "#162C1F",
                                                width: 40,
                                                height: 40,
                                                fontWeight: "bold",
                                                fontSize: "1rem",
                                            }}
                                        >
                                            {day.substring(0, 3)}
                                        </Avatar>

                                        {/* Start Time */}
                                        <Box sx={{ flex: 1 }}>
                                            <Controller
                                                name={startField}
                                                control={control}
                                                render={({ field }) => {
                                                    const isOffline = !!watch(offlineField);
                                                    return (
                                                        <TimePicker
                                                            label="Start"
                                                            disabled={isOffline}
                                                            value={field.value ? dayjs(field.value) : null}
                                                            onChange={(newValue) =>
                                                                newValue
                                                                    ? field.onChange(newValue.toISOString())
                                                                    : field.onChange(null)
                                                            }
                                                            slotProps={{
                                                                textField: {
                                                                    fullWidth: true,
                                                                    error: !isOffline && !!errors?.[startField],
                                                                    helperText:
                                                                        !isOffline && errors?.[startField]?.message,
                                                                },
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                        </Box>

                                        <ArrowRightAltIcon color="action" />

                                        {/* End Time */}
                                        <Box sx={{ flex: 1 }}>
                                            <Controller
                                                name={endField}
                                                control={control}
                                                render={({ field }) => {
                                                    const isOffline = !!watch(offlineField);
                                                    return (
                                                        <TimePicker
                                                            label="End"
                                                            disabled={isOffline}
                                                            value={field.value ? dayjs(field.value) : null}
                                                            onChange={(newValue) =>
                                                                newValue
                                                                    ? field.onChange(newValue.toISOString())
                                                                    : field.onChange(null)
                                                            }
                                                            slotProps={{
                                                                textField: {
                                                                    fullWidth: true,
                                                                    error: !isOffline && !!errors?.[endField],
                                                                    helperText:
                                                                        !isOffline && errors?.[endField]?.message,
                                                                },
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                        </Box>

                                        {/* Offline Checkbox */}
                                        <Controller
                                            name={offlineField}
                                            control={control}
                                            render={({ field }) => (
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            {...field}
                                                            checked={field.value || false}
                                                            onChange={(e) => field.onChange(e.target.checked)}
                                                            sx={{
                                                                color: "#162C1F",
                                                                '&.Mui-checked': {
                                                                    color: "#162C1F",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label="Closed"
                                                />
                                            )}
                                        />
                                    </Box>
                                )
                            })
                            }
                        </Box>
                    </LocalizationProvider>


                    {/* Gallery Upload */}
                    <Box sx={{ marginBottom: 3 }}>
                        <Typography variant="h6" gutterBottom>
                            Gallery
                        </Typography>
                        <Box
                            {...getRootProps()}
                            sx={{
                                border: "2px dashed #cccccc",
                                borderRadius: "8px",
                                padding: 2,
                                textAlign: "center",
                                backgroundColor: "#fafafa",
                            }}
                        >
                            <input {...getInputProps()} />
                            <Typography>Drag and drop images here, or click to select</Typography>
                        </Box>
                        <Box sx={{ marginTop: 2 }}>
                            {[...oldGalleryImages, ...uploadedImages.map((item) => item.previewUrl)].map(
                                (src, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            marginBottom: 1,
                                            padding: 1,
                                            border: "1px solid #cccccc",
                                            borderRadius: "5px",
                                            backgroundColor: "#ffffff",
                                        }}
                                    >
                                        <CardMedia component="img" height="140" image={src} />
                                        <IconButton
                                            onClick={() => handleRemoveImage(index)}
                                            sx={{ color: "#ff4d4d" }}
                                        >
                                            <Close />
                                        </IconButton>
                                    </Box>
                                )
                            )}
                        </Box>
                    </Box>

                    {/* Banking Info */}
                    <Typography variant="h6" gutterBottom>
                        Banking Details
                    </Typography>

                    <Box sx={{ marginBottom: 3 }}>
                        <Controller
                            name="accountNumber"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    label="Account Number"
                                    fullWidth
                                    {...field}
                                    onChange={(e) => {
                                        field.onChange(e.target.value);
                                        setRestaurantBankingDetails((prev) => ({
                                            ...prev,
                                            accountNumber: e.target.value,
                                        }));
                                    }}
                                    error={!!errors.accountNumber}
                                    helperText={errors.accountNumber?.message}
                                />
                            )}
                        />
                    </Box>

                    <Box sx={{ marginBottom: 3 }}>
                        <Controller
                            name="branchCode"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    label="Branch Code"
                                    fullWidth
                                    {...field}
                                    onChange={(e) => {
                                        field.onChange(e.target.value);
                                        setRestaurantBankingDetails((prev) => ({
                                            ...prev,
                                            branchCode: e.target.value,
                                        }));
                                    }}
                                    error={!!errors.branchCode}
                                    helperText={errors.branchCode?.message}
                                />
                            )}
                        />
                    </Box>

                    {/* Submit Button */}
                    <Box sx={{ textAlign: "center", marginTop: 4 }}>
                        <Button
                            onClick={() => handleSubmit(onSubmit)()}
                            variant="contained"
                            sx={{
                                backgroundColor: "#162C1F",
                                paddingX: 4,
                                paddingY: 1.5,
                                borderRadius: "24px",
                                "&:hover": { backgroundColor: "#162C1F" },
                            }}
                        >
                            {loading ? <CircularProgress size={24} /> : editRestaurant ? "Save Restaurant" : "Create Restaurant"}
                        </Button>
                        {errorMessage && (
                            <Typography color="error" variant="body2" sx={{ marginTop: 2 }}>
                                {errorMessage}
                            </Typography>
                        )}
                    </Box>
                </Box>

                <ConfirmActionDialog
                    isOpen={showDeactivateRestaurantConfirmationDialog}
                    onClose={() => setShowDeactivateRestaurantConfirmationDialog(false)}
                    onConfirm={() => handleSubmitResaurant(restaurantFormData!)}
                    title="Confirm Deactivating Restaurant"
                >
                    Deactivate the restaurant
                    <p />
                    You will need to contact Eco Eats to reactivate your store.
                </ConfirmActionDialog>
            </Box>
        </form>

    );
};
